import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type fetchAttestModel = {
  id: string | number
}

export const fetchAttest = ({ id }: fetchAttestModel) => {
  return new PsychologicalDocumentsUseCase(
    `/atestado/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveAttest = ({ id }: fetchAttestModel) => {
  return new PsychologicalDocumentsUseCase(
    `/atestado/save/${id}`,
    makeAxiosHttpClient()
  )
}

export const updateAttest = ({ id }: fetchAttestModel) => {
  return new PsychologicalDocumentsUseCase(
    `/atestado/update/${id}`,
    makeAxiosHttpClient()
  )
}

export const resetAttest = ({ id }: fetchAttestModel) => {
  return new PsychologicalDocumentsUseCase(
    `/atestado/reset/${id}`,
    makeAxiosHttpClient()
  )
}
